import { ActionBase } from '../../../core/store/action/ActionBase';

export const GET_USER_SUBMITTING_ENTITIES = '[Customer] Get User Submitting Entities';

export class GetUserSubmittingEntitiesAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_USER_SUBMITTING_ENTITIES;

  constructor(public payload: { userKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GetUserSubmittingEntitiesAction.ts